export const DEFAULT_POST_CONFIG = {
    hasHover: true,
    hasFooter: true,
    showLabels: true,
    showAlbums: true
};
